export default __webpack_public_path__ + "static/new8-09-ba82b2f76eeef2420a1aeef396b78a56.jpg";